import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 21h-5v-5h-5v-5h-5v-5h-5","key":"svg-0"}],["path",{"d":"M18 3v7","key":"svg-1"}],["path",{"d":"M15 7l3 3l3 -3","key":"svg-2"}]]

const IconStairsDown = createReactComponent('outline', 'stairs-down', 'StairsDown', __iconNode);

export default IconStairsDown;